module.exports = __webpack_public_path__ + "static/img/bg_banner.bf9b5de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_banner.png
// module id = TECf
// module chunks = 1